import React from 'react'
import DataGrid, { Paging, Pager } from 'devextreme-react/data-grid';

import saveAs from 'file-saver'
import { Workbook } from 'exceljs'
import withRouter from '../helpers/withRouter'

import { exportDataGrid } from 'devextreme/excel_exporter'
import { Template } from 'devextreme-react';
import { RenderPerformanceMetric } from '../renderers/renderPerformanceMetric';
import { renderImportantMetric } from '../renderers/renderImportantMetric';

class DataGridGeneric extends React.Component {
  allowedPageSizes = [10, 20, 50];
  exportFormats = ['xlsx'];
  exportGrid(e) {
    if (e.format === 'xlsx') {
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet("Main sheet")

        exportDataGrid({
            worksheet,
            component: e.component
        }).then(function() {
            workbook.xlsx.writeBuffer().then(function(buffer) {
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx")
            })
        })

        e.cancel = true
    }
  }


  render() { 
    return (
        <DataGrid
          keyExpr="resourceName"
          dataSource={this.props.dataSource}
          columns={this.props.columns}
          allowColumnReordering={true}
          allowHeaderFiltering={true}
          export={{ enabled: true, formats: this.exportFormats}}
          onExporting={this.exportGrid}                  
          headerFilter={{ visible: true, allowSearch: true}}
          groupPanel={{ visible: false }}
          loadPanel={{ enabled: true }}
          allowColumnResizing={true}
          columnAutoWidth={true}
          showBorders={true}
          showColumnLines={true}
          showRowLines={true}
          rowAlternationEnabled={true}  
          width={"100%"}
        >    
          <Paging
            enabled={true}
            defaultPageIndex={0}
            defaultPageSize={10} 
          />    
          <Pager 
            visible={true}
            allowedPageSizes={this.allowedPageSizes}
            showInfo={true}
            showPageSizeSelector={true}
            showNavigationButtons={true}
          />          
          <Template name="performanceMetric" render={RenderPerformanceMetric} />
          <Template name="importanceMetric" render={renderImportantMetric} />
        </DataGrid>
    );
  }
}

export default withRouter(DataGridGeneric);